import { render } from "./list-share-settings.vue?vue&type=template&id=016bd0cb&scoped=true&ts=true"
import script from "./list-share-settings.vue?vue&type=script&lang=ts"
export * from "./list-share-settings.vue?vue&type=script&lang=ts"

import "./list-share-settings.vue?vue&type=style&index=0&id=016bd0cb&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-016bd0cb"]])

export default __exports__